<ui-section
	title="Mortgage Broker"
	[isEmpty]="!_mortgage?.brokerage && !showBrokerageSearch"
	emptyMessage="There are no Mortgage Brokers in this file."
>
	<ui-button
		title-action
		(click)="toggleShowSearchBrokerage()"
		label="Add"
		icon="plus"
		preset="MEDIUM_EMPHASIS"
	/>
	<div section-content>
		<app-input
			*ngIf="_mortgage?.brokerage"
			[@openClose]
			label="Broker fees"
			type="cents"
			[startIcon]="ICON.DOLLAR"
			[ngModel]="_mortgage.brokerFee"
			(ngModelChange)="updateFee($event)"
		></app-input>

		<div
			class="mt-4"
			*ngIf="!_mortgage?.brokerage && showBrokerageSearch"
			[@openClose]
		>
			<app-search-mortgage-brokerage-input
				(onSelectedBrokerage)="onSelectMortgageBrokerage($event)"
				(onSelectedBroker)="onSelectMortgageBroker($event)"
				(onCreateBrokerage)="onCreateBrokerage($event)"
			></app-search-mortgage-brokerage-input>
		</div>

		<div class="mt-4" *ngIf="_mortgage?.brokerage" [@openClose]>
			<app-firm-card
				[name]="_mortgage?.brokerage?.name"
				[address]="setAddress(_mortgage?.brokerage?.address)"
				[phone]="_mortgage?.brokerage?.phoneNumber"
				[fax]="_mortgage?.brokerage?.faxNumber"
				[email]="_mortgage?.brokerage?.email"
				member="BROKERAGE"
				memberType="Business"
				[hoverShadow]="true"
				(dropdown)="brokerageDropdownOptionSelect($event)"
			>
			</app-firm-card>
		</div>

		<div
			*ngIf="!_mortgage?.brokerage?.broker && _mortgage?.brokerage"
			class="mt-4"
			[@openClose]
		>
			<app-search-mortgage-broker-input
				(onSelectedBroker)="onSelectMortgageBroker($event)"
				(onCreateBroker)="onCreateBroker($event)"
			></app-search-mortgage-broker-input>
		</div>

		<div class="mt-4" *ngIf="_mortgage?.brokerage?.broker" [@!openClose]>
			<app-member-card
				[firstName]="_mortgage?.brokerage?.broker?.firstName"
				[lastName]="_mortgage?.brokerage?.broker?.lastName"
				[email]="_mortgage?.brokerage?.broker?.email"
				[phone]="_mortgage?.brokerage?.broker?.phoneNumber"
				member="BROKER"
				memberType="Agent"
				[hoverShadow]="true"
				(dropdown)="brokerDropdownOptionSelect($event)"
			>
			</app-member-card>
		</div>
	</div>
</ui-section>
